import { ArrowForwardIos } from "@mui/icons-material";
import { Box, Card, CardContent } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { Typography } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { default as api, default as Api } from "../API/api";
import { loginState, WHState } from "../Atom/AtomState";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import FileComponent from "../CommonComponent/Inputs/FileComponent";
import TextComponent from "../CommonComponent/Inputs/TextComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";
import "../CSS/PageCSS/NoticeDetailPage.css";

const { Title } = Typography;

export default function CustomerResultPage() {
  const location = useLocation();
  const key = location.state;
  let navigate = useNavigate();
  const LoginState = useRecoilValue(loginState);
  const WH = useRecoilValue(WHState);
  const [divboxHeight, setdivBoxHeight] = useState<number>(0);
  const [notice, setNotice] = useState<any>({
    p_id: 0,
    name: LoginState?.name,
    title: "",
    content: "",
    insert_time: "",
    end_date: dayjs(new Date()),
  });
  const [uploadedFiles, setUploadedFiles]: any[] = useState([]);
  const [deleteFiles, setDeleteFiles]: any[] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const upload = (value: any) => {
    setUploadedFiles([...uploadedFiles, ...value]);
  };

  const onDelete = (index: any) => {
    setDeleteFiles([...deleteFiles, uploadedFiles[index]]);
    const updatedArray = [...uploadedFiles];
    updatedArray.splice(index, 1);
    setUploadedFiles(updatedArray);
  };

  const DownloadFile = (file: any) => {
    const getData = async () => {
      setLoading(true);
      const files: any = await api.getfile(
        `/Notice/downloadFile?p_id=${file.p_id}`,
        file.name
      );
      setLoading(false);
    };
    getData();
  };

  const changeTextField = (value: any) => {
    if (value.name == "title") {
      setNotice((prev: any) => ({
        ...prev,
        title: value.value,
      }));
    } else if (value.name == "content") {
      setNotice((prev: any) => ({
        ...prev,
        content: value.value,
      }));
    }
  };

  const changeDateField = (value: any, name: any) => {
    if (name == "end_date") {
      setNotice((prev: any) => ({
        ...prev,
        end_date: value,
      }));
    }
  };

  const handleSave = () => {
    if (LoginState != null) {
      if (key.state == "register") {
        const getInsert = async () => {
          setLoading(true);
          const formData = new FormData();
          formData.append("employee_id", LoginState?.p_id.toString());
          formData.append("title", notice.title);
          formData.append("content", notice.content);
          formData.append(
            "end_date",
            notice.end_date.format("YYYY-MM-DD HH:mm:ss")
          );

          for (let i = 0; i < uploadedFiles.length; i++) {
            formData.append("files", uploadedFiles[i]);
          }

          const register = await Api.postfile(`/Notice/insertNotice`, formData);
          setLoading(false);
          if (register != undefined) {
            navigate("/NoticePage");
          } else {
            setAlert(true);
            setAlertMessage("공지사항 등록에 실패하였습니다.");
          }
        };
        if (
          notice.title == "" ||
          notice.content == "" ||
          !notice.end_date.isValid()
        ) {
          setAlert(true);
          setAlertMessage("필수값을 채워주세요.");
        } else {
          getInsert();
        }
      } else if (key.state == "update") {
        const getUpdate = async () => {
          setLoading(true);
          const formData = new FormData();
          formData.append("p_id", notice.p_id);
          formData.append("title", notice.title);
          formData.append("content", notice.content);
          formData.append(
            "end_date",
            notice.end_date.format("YYYY-MM-DD HH:mm:ss")
          );
          formData.append("deleteFiles", JSON.stringify(deleteFiles));
          for (let i = 0; i < uploadedFiles.length; i++) {
            formData.append("files", uploadedFiles[i]);
          }

          const updateData = await Api.putfile(
            `/Notice/updateNotice`,
            formData
          );
          setLoading(false);
          if (updateData != undefined) {
            navigate(0);
          } else {
            setAlert(true);
            setAlertMessage("공지사항 정보 수정에 실패하였습니다.");
          }
        };
        if (
          notice.title == "" ||
          notice.content == "" ||
          !notice.end_date.isValid()
        ) {
          setAlert(true);
          setAlertMessage("필수값을 채워주세요.");
        } else {
          getUpdate();
        }
      }
    }
  };

  useEffect(() => {
    if (key == null) {
      navigate("/NotFoundPage");
    } else {
      if (key.state != "register") {
        const getData = async () => {
          setLoading(true);
          const notice = await api.get(
            `/Notice/getNoticeInfo?p_id=${key.p_id}`
          );
          setLoading(false);
          if (notice != undefined) {
            const newItem = {
              ...notice[0].notice[0],
              end_date: dayjs(notice[0].notice[0].end_date),
            };
            if (notice[0].files.length > 0) {
              setUploadedFiles(notice[0].files);
            }
            setNotice(newItem);
          } else {
            setAlert(true);
            setAlertMessage("데이터 조회에 실패하였습니다.");
          }
        };
        getData();
      }
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const div = document.getElementById("divbox") as HTMLElement;
      const NoticeDetailControlDiv = document.getElementById(
        "NoticeDetailControlDiv"
      ) as HTMLElement;
      if (div && NoticeDetailControlDiv) {
        setdivBoxHeight(
          div.clientHeight - NoticeDetailControlDiv.clientHeight - 40
        );
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div style={{ height: WH.height - 160 }}>
      <Title level={2} className="NoticeDetailPageTitle">
        NoticeDetailPage
      </Title>
      <div id="divbox">
        <Card className="NoticeDetailCard">
          <CardContent
            className="NoticeDetailCardContent"
            sx={{
              height: divboxHeight,
            }}
          >
            <Box className="NoticenDetailForm">
              <Title level={4} className="NoticeDetailName">
                제목
              </Title>
              {key && key.state == "view" ? (
                <Title level={5} className="NoticeDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="NoticeAnswerIcon"
                  />
                  {notice.title}
                </Title>
              ) : (
                <TextComponent
                  variant="standard"
                  value={notice.title}
                  name="title"
                  fullWidth
                  onChange={changeTextField}
                />
              )}
            </Box>
            <Box className="NoticenDetailForm">
              <Title level={4} className="NoticeDetailName">
                작성자
              </Title>
              <Title level={5} className="NoticeDetailName">
                <ArrowForwardIos
                  fontSize="small"
                  className="NoticeAnswerIcon"
                />
                {notice.name}
              </Title>
            </Box>
            <Box className="NoticenDetailForm">
              <Title level={4} className="NoticeDetailName">
                공지만료일자
              </Title>
              {key && key.state == "view" ? (
                <Title level={5} className="NoticeDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="NoticeAnswerIcon"
                  />
                  {notice.end_date.format("YYYY-MM-DD HH:mm:ss")}
                </Title>
              ) : (
                <DatePicker
                  value={notice.end_date}
                  onChange={(value: any) => changeDateField(value, "end_date")}
                  format="YYYY-MM-DD"
                  sx={{ width: "100%" }}
                />
              )}
            </Box>
            <Box className="NoticenDetailForm">
              <Title level={4} className="NoticeDetailName">
                내용
              </Title>
              {key && key.state == "view" ? (
                <Title level={5} className="NoticeDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="NoticeAnswerIcon"
                  />
                  {notice.content}
                </Title>
              ) : (
                <TextComponent
                  variant="standard"
                  value={notice.content}
                  name="content"
                  fullWidth
                  rows={5}
                  multiline
                  onChange={changeTextField}
                />
              )}
            </Box>
            <Box className="NoticenDetailForm">
              <Title level={4} className="NoticeDetailName">
                첨부파일
              </Title>
              {key && key.state == "view" ? (
                <Title level={5}>
                  {uploadedFiles.map((file: any, index: any) => (
                    <Title
                      key={index}
                      level={5}
                      className="NoticeFileDetailName"
                    >
                      <div>
                        <ArrowForwardIos
                          fontSize="small"
                          className="AnswerIcon"
                        />
                        {file.name}
                      </div>
                      <ButtonComponent
                        fullWidth
                        variant="contained"
                        onClick={() => DownloadFile(file)}
                        className="NoticeCancelButton"
                      >
                        다운로드
                      </ButtonComponent>
                    </Title>
                  ))}
                </Title>
              ) : (
                <div>
                  <FileComponent
                    value={uploadedFiles}
                    upload={upload}
                    onDelete={onDelete}
                  />
                </div>
              )}
            </Box>
          </CardContent>
          <Box id="NoticeDetailControlDiv">
            {key && key.state != "view" && (
              <ButtonComponent
                fullWidth
                variant="contained"
                onClick={() => handleSave()}
                className="NoticeSaveButton"
              >
                저장
              </ButtonComponent>
            )}
            <ButtonComponent
              fullWidth
              variant="contained"
              onClick={() => {
                if (!LoginState?.manager) {
                  navigate("/");
                } else {
                  navigate("/NoticePage");
                }
              }}
              className="NoticeCancelButton"
            >
              취소
            </ButtonComponent>
          </Box>
        </Card>
      </div>
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </div>
  );
}
